export const API_BASE_URL = (code: string, idStudent: string) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/classes/${code}/register/${idStudent}`;

export const API_BASE_URL_CLASS = `${process.env.REACT_APP_API_URL}/classes`;
